export default __webpack_public_path__ + "static/media/seva-type.0dbc5335.png";